module.exports = __webpack_public_path__ + "img/stat_03_icon.2c4bf187.png";